
//http://68.178.203.106:5000/api/web/

// import companyName from '../store/mobxStore/companyName';
// const COMPANY_NAME = companyName.companyName ?? 'Company Name';
// const BASE_URL = "http://68.178.203.106:5000/node_api/web/";
// const IMG_URL = "http://68.178.203.106:5000/node_api/uploads/images/";
// const LEAD_URL = "http://68.178.203.106:5000/node_api/uploads/images/";
// const API_KEY = localStorage.getItem('apiKey'); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = '07c74a0b-1f8a-40a2-8d7f-8724503ed48f'
// const BASE = "http://68.178.203.106:5000";
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY,
//     LEAD_URL
// }

// //local

// import companyName from '../store/mobxStore/companyName';
// const COMPANY_NAME = companyName?.companyName ?? 'Company Name';
// const BASE_URL = "http://192.168.9.2:3178/node_api/web/";
// const IMG_URL = "http://192.168.9.9:5021/uploads/images/";
// const LEAD_URL = "http://192.168.9.9:5021/api/web/";
// const API_KEY = localStorage.getItem('apiKey'); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = '07c74a0b-1f8a-40a2-8d7f-8724503ed48f'
// const BASE = "http://192.168.23.44:5000/";
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY,
//     LEAD_URL
// }

//demo


// import companyName from '../store/mobxStore/companyName';
// const COMPANY_NAME = companyName.companyName ?? 'Company Name';
// const BASE_URL = "https://emma.admin.infinitemlmdemo.com/node_api/web/";
// const IMG_URL = "https://emma.admin.infinitemlmdemo.com/uploads/images/";
// const LEAD_URL = "https://emma.admin.infinitemlmdemo.com/api/web/";
// const API_KEY = localStorage.getItem('apiKey'); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = '07c74a0b-1f8a-40a2-8d7f-8724503ed48f'
// const BASE = "https://emma.admin.infinitemlmdemo.com";
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY,
//     LEAD_URL
// }

//live
import companyName from '../store/mobxStore/companyName';
const COMPANY_NAME = companyName.companyName ?? 'Company Name';
const BASE_URL = "https://admin.legacylifechoice.com/node_api/web/";
const IMG_URL = "https://admin.legacylifechoice.com/uploads/images/";
const LEAD_URL = "https://admin.legacylifechoice.com/api/web/";
const API_KEY = localStorage.getItem('apiKey'); //binaryaddon;
// const DEFAULT_KEY ='903's
const DEFAULT_KEY = '07c74a0b-1f8a-40a2-8d7f-8724503ed48f'
const BASE = "https://admin.legacylifechoice.com";
export {
    COMPANY_NAME,
    BASE_URL,
    IMG_URL,
    API_KEY,
    BASE,
    DEFAULT_KEY,
    LEAD_URL
}
